import asyncAction from 'modules/core/lib/asyncAction'
import { Model } from 'modules/core/lib/mobx-rest'

type SectionType = 'values' | 'benefits' | 'team' | 'jobs' | 'offices'

interface ICareerSection {
  ats_company_id: number
  description?: string
  enabled: boolean
  title: string
  type: SectionType
}

class CareerSection extends Model<ICareerSection> {
  static defaultSection = 'header'

  static urlRoot() {
    return '/ats/sections'
  }

  async toggleSection() {
    const result = await asyncAction(() => this.rpc('toggle_enable', {}), {
      successFlash: false,
    })

    if (result.success) {
      this.set({
        enabled: result.value.enabled,
      })
    }

    return Promise.resolve(result)
  }
}

export default CareerSection
